import { faChevronDown, faChevronUp, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, useMantineTheme } from '@mantine/core';
import classes from './DataGridFiltersTargetContent.module.css';
import clsx from 'clsx';

export interface DataGridFiltersTargetContentProps {
  open: boolean;
  label: string;
  value: string;
  onClear?: VoidFunction;
}

export function DataGridFiltersTargetContent({ open, label, value, onClear }: DataGridFiltersTargetContentProps) {
  const theme = useMantineTheme();

  return (
    <Group component="div" c="blue" className={classes.dataGridFiltersSelectorLabel}>
      <span className={classes.dataGridFiltersSelectorLabelText}>
        {label}
        {value?.length > 0 ? ': ' : ''}
      </span>
      {value}

      {!value ? (
        <FontAwesomeIcon
          className={classes.dataGridFiltersSelectorLabelIcon}
          icon={open ? faChevronUp : faChevronDown}
          color={value?.length < 1 ? theme.colors.gray[5] : theme.colors.blue[5]}
        />
      ) : (
        <FontAwesomeIcon
          className={clsx(classes.dataGridFiltersSelectorLabelIcon, classes.dataGridFiltersSelectorLabelClearIcon)}
          icon={faXmark}
          onClick={(e) => {
            e.stopPropagation();
            onClear?.();
          }}
        />
      )}
    </Group>
  );
}
